// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect } from "react";
import {
  signupRequest,
  loginRequest,
  passwordRequest,
  reinitPasswordRequest,
  getMeRequest,
} from "../api/auth";

export const AuthContext = createContext({
  user: null,
  isLogin: null,
  setIsLogin: () => {},
  signup: async () => {},
  login: async () => {},
  logout: () => {},
  authError: null,
  setAuthError: () => {},
  registerActivitiesInterest: () => {},
  completeOnboarding: () => {},
  updateUser: () => {}
});

export function AuthProvider({ children }) {
  const [authError, setAuthError] = useState(null)
  const [isLogin, setIsLogin] = useState(null)
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (user) localStorage.setItem("user", JSON.stringify(user));
    else localStorage.removeItem("user");
  }, [user]);

  // Rafraîchir les données utilisateur au démarrage
  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      getMeRequest()
        .then((data) => {
          setUser({ ...data, authToken });
        })
        .catch(() => {
          // Token invalide, déconnecter l'utilisateur
          logout();
        });
    }
  }, []);

  async function signup(data) {
    try {
      setIsLogin(false);
      const { id, authToken } = await signupRequest(data);
      localStorage.setItem("authToken", authToken);
      const newUser = { ...data, authToken, id, onboarding_completed: false }
      setUser(newUser)
      setAuthError(null)
      return newUser
    } catch (e) {
      setAuthError(e.response.data.message)
      return null
    }
  }

  const registerActivitiesInterest = () => {
    const newUser = { ...user, activities_interest: true }
    setUser(newUser)
  }

  const completeOnboarding = (prenom, gender) => {
    const newUser = {
      ...user,
      onboarding_completed: true,
      firstName: prenom || user.firstName,
      gender: gender || user.gender
    }
    setUser(newUser)
  }

  async function password(data) {
    try {
      setAuthError(null)
      await passwordRequest(data);
    } catch (e) {
      setAuthError(e.response.data.message)
      return null
    }
  }

  async function reinitPassword(data) {
    try {
      setAuthError(null)
      await reinitPasswordRequest(data);
    } catch (e) {
      setAuthError(e.response.data.message)
      return null
    }
  }

  async function login(data) {
    try {
      setIsLogin(true);
      const { user, authToken } = await loginRequest(data);
      localStorage.setItem("authToken", authToken);
      const newUser = { ...user, authToken }
      setUser(newUser)
      setAuthError(null)
      return newUser
    } catch (e) {
      setAuthError(e.response.data.message)
      return null
    }
  }

  const logout = () => {
    setUser(null);
    localStorage.removeItem("authToken");
    localStorage.removeItem("conversations");
    localStorage.removeItem("activities");
    localStorage.removeItem("selectedFilters");
    localStorage.removeItem("itemsPro");
    localStorage.removeItem("feedback");
  }

  const updateUser = (updatedUserData) => {
    const authToken = localStorage.getItem("authToken");
    setUser({ ...updatedUserData, authToken });
  }

  return (
    <AuthContext.Provider value={{ user, isLogin, setIsLogin, signup, login, logout, password, reinitPassword, authError, setAuthError, registerActivitiesInterest, completeOnboarding, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}
